import { testimonials } from '@/mocks/mangaData';

export default function Testimonials() {
  return (
    <section id="reviews" className="mx-auto max-w-7xl px-4 py-16 md:px-6 md:py-24">
      <div className="flex flex-col items-center text-center">
        <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-4 py-1.5 text-xs font-semibold text-secondary-800">
          <i className="ri-chat-heart-line text-sm" />
          用户口碑
        </span>
        <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
          12 万追更用户的选择
        </h2>
        <div className="mt-4 flex items-center gap-2">
          <span className="flex items-center gap-0.5">
            {Array.from({ length: 5 }).map((_, i) => (
              <i key={i} className="ri-star-fill text-lg text-accent-500" />
            ))}
          </span>
          <span className="text-sm font-semibold text-foreground-700">4.9 / 5.0</span>
        </div>
      </div>

      <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-3">
        {testimonials.map((t) => (
          <figure
            key={t.id}
            className="flex flex-col rounded-2xl bg-background-50 p-6 ring-1 ring-background-200"
          >
            <i className="ri-double-quotes-l text-3xl text-primary-200" />
            <blockquote className="mt-2 flex-1 text-sm leading-relaxed text-foreground-700">
              “{t.quote}”
            </blockquote>
            <figcaption className="mt-5 flex items-center gap-3">
              <span
                className={`flex h-10 w-10 items-center justify-center rounded-full text-sm font-bold ${t.avatarColor}`}
              >
                {t.name.slice(0, 1)}
              </span>
              <div>
                <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                <p className="text-xs text-foreground-500">{t.role}</p>
              </div>
            </figcaption>
          </figure>
        ))}
      </div>
    </section>
  );
}